import { GrowthBook } from '@growthbook/growthbook-react';
import { getAppConfig } from 'app/getConfig';

export const growthbook = new GrowthBook({
  enableDevMode: getAppConfig().NODE_ENV === 'development',
});
